import { TimelineEventStatus } from './enums/timeline-event-status.enum';
import { TimelineParty } from './enums/timeline-party.enum';
import { TimelineTempo } from './enums/timeline-tempo.enum';
import { TimelineAction } from './timeline-actions.model';
import { TimelineEventDependency } from './timeline-event-dependency.model';

export interface TimelineEvent {
    id: string;
    stage: number;
    stageName?: string;
    name: string;
    party: TimelineParty;
    dependencies: TimelineEventDependency[];
    slowTempoDurationDays: number;
    mediumTempoDurationDays: number;
    fastTempoDurationDays: number;
    dayStart: number;
    dayCompleted?: number;
    dayEnd: number;
    actualStartDay?: number;
    linkedAction: TimelineAction;
    status: TimelineEventStatus;
    currentTempoDurationDays: number;
    currentTempo: TimelineTempo;
    isSuspendEvent: boolean;
}

export const UpdateEventStatus = (
    event: TimelineEvent,
    newStatus: TimelineEventStatus
): TimelineEvent => {
    return {
        ...event,
        status: newStatus,
    };
};
